export default {"src":"https://fishbrain.com/_next/static/media/3.246259b3.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};